import { useEffect, useContext } from "react";
import { Box, Button } from '@mui/material';
import { Sync as SyncIcon } from '@mui/icons-material';
import { SalesProductReport } from "../../../../global/API";
import { ToolContext } from "../../../../../../core/context/ToolContext";

import { FeatureIdState } from "../../../../toolUsage/global/GlobalFcn";
import { CreateFeatureLogs } from "../../../../global/API";


export const Generate = () => {
    const { tool_state, report_state, global_component_state } = useContext(ToolContext);
    const { __SESSION } = tool_state;
    const { form, comProductIds, generateForm, salesProductData, salesProductList } = report_state;
    const { snackBarLoader } = global_component_state;
    const tool_id = process.env.REACT_APP_TID_BIZ;

    const SendFeatureLogs = async () => {
        const body = {
            aid: __SESSION.data.ainfo.aid,
            path: `${FeatureIdState("reports")}->2`,
            feature_id: 1,
            feature_name: "branch-product-sales-report",
            tid: tool_id,
            company_id: __SESSION.data.uaccess[0].company_id,
            action: 2,
        };
        await CreateFeatureLogs(body);
    };

    const FinalData = (rows) => {
        salesProductData.set(rows);
        salesProductList.set(rows);
        generateForm.set((prev) => ({ ...prev, infiniteLoad: false, offset: 0 }));
    };

    const handleGenerate = async () => {
        if (
            form.data.to === "" ||
            form.data.from === "" ||
            form.data.to < form.data.from
        ) {
            snackBarLoader.set({
                ...snackBarLoader.data,
                snackbar: true,
                msg: "Invalid Date!",
                type: "error",
            });
            return;
        }

        generateForm.set((prev) => ({
            ...prev,
            infiniteLoad: true,
            offset: 0,
        }));

        salesProductData.set([]);
        salesProductList.set([]);

        try {
            const limit = generateForm.data.limit;
            let offset = 0;
            let allRows = [];
            let shouldContinue = true;

            while (shouldContinue) {
                const qsp = {
                    branch_id: form.data.branch_id,
                    company_id: __SESSION.data.uaccess[0].company_id,
                    product_id:
                        form.data.product_id > 0
                            ? form.data.branch_id === 0
                                ? JSON.stringify(comProductIds)
                                : JSON.stringify([form.data.product_id])
                            : form.data.product_id,
                    from: form.data.from,
                    to: form.data.to,
                    limit,
                    offset,
                };

                let res = await SalesProductReport(qsp);

                if (!res || !Array.isArray(res)) {
                    shouldContinue = false;
                    break;
                }

                res = res.filter((item) => parseInt(item.visible) === 1);

                if (res.length === 0) {
                    shouldContinue = false;
                    break;
                }

                allRows = [...allRows, ...res];
                offset += res.length;

                generateForm.set((prev) => ({
                    ...prev,
                    offset,
                }));

                if (res.length < limit) {
                    shouldContinue = false;
                }
            }

            FinalData(allRows);
            await SendFeatureLogs();
        } catch (error) {
            console.error(error);
            generateForm.set((prev) => ({ ...prev, infiniteLoad: false, offset: 0 }));
            snackBarLoader.set({
                ...snackBarLoader.data,
                snackbar: true,
                msg: "Failed to generate report.",
                type: "error",
            });
        }
    };

    return (
        <Box minHeight="55px" display="flex" flexDirection="column" justifyContent="flex-end" alignItems="center" gap={2} width="100%">
            <Box id="walkthrough-branch-product-report-step-5" onClick={handleGenerate} component={Button} disableFocusRipple={true} minHeight="50px" minWidth="130px" borderRadius={3} display="flex" alignItems="center" justifyContent="center" bgcolor="primary.main" color="#fff" sx={{gap: 2, width: "100%", border:"2px solid #EBEBEB", ':hover':{bgcolor:'primary.main', color:'#FFFFFF'}}}>
                <SyncIcon/>
                <Box fontSize={16} fontWeight={400} lineHeight="19px">Generate</Box>
            </Box>
        </Box>
    )
}